import React, { useState, useEffect } from 'react';
import api from '../api/client';

const btnPrimary = { padding: '8px 16px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 500, fontSize: 13, cursor: 'pointer' };
const btnDanger = { padding: '7px 12px', background: 'none', border: '1px solid #c0392b', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: '#c0392b' };

export default function Blacklist() {
  const [entries, setEntries] = useState([]);
  const [text, setText] = useState('');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const load = async () => { const { data } = await api.get('/blacklist'); setEntries(data); };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!text.trim()) return;
    setLoading(true);
    try {
      await api.post('/blacklist', { targets_text: text, reason: reason || undefined });
      setText(''); setReason('');
      await load();
    } catch (e) { alert(e.response?.data?.detail || 'Ошибка'); }
    setLoading(false);
  };

  const del = async (id) => {
    await api.delete(`/blacklist/${id}`);
    await load();
  };

  return (
    <div style={{ padding: 32 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>Чёрный список</h1>
          <div style={{ fontSize: 13, color: '#888', marginTop: 4 }}>Контакты из этого списка не получат сообщений при рассылке</div>
        </div>
      </div>

      {/* Добавление */}
      <div style={{ background: '#fff', border: '1px solid #e8e8e6', borderRadius: 10, padding: 16, marginBottom: 20 }}>
        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8 }}>Добавить в чёрный список</div>
        <div style={{ fontSize: 12, color: '#aaa', marginBottom: 8 }}>Номера и username — каждый с новой строки</div>
        <textarea value={text} onChange={e => setText(e.target.value)}
          placeholder={"+79001234567\n@username\n89001234567"}
          rows={4}
          style={{ width: '100%', padding: '9px 12px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, fontFamily: 'monospace', resize: 'vertical', boxSizing: 'border-box', outline: 'none', marginBottom: 8 }}
        />
        <input value={reason} onChange={e => setReason(e.target.value)}
          placeholder="Причина (необязательно)"
          style={{ width: '100%', padding: '8px 12px', border: '1px solid #e8e8e6', borderRadius: 8, fontSize: 13, boxSizing: 'border-box', outline: 'none', marginBottom: 10 }}
        />
        <button onClick={add} disabled={loading} style={btnPrimary}>{loading ? 'Добавляем...' : '+ Добавить'}</button>
      </div>

      {/* Список */}
      <div style={{ marginBottom: 10, fontSize: 13, color: '#888' }}>
        Всего в чёрном списке: <b>{entries.length}</b>
      </div>
      {entries.length === 0 && <div style={{ textAlign: 'center', padding: 60, color: '#aaa', fontSize: 14 }}>Чёрный список пуст</div>}
      <div style={{ display: 'grid', gap: 6 }}>
        {entries.map(e => (
          <div key={e.id} style={{ background: '#fff', border: '1px solid #e8e8e6', borderRadius: 8, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontFamily: 'monospace', fontSize: 13, flex: 1 }}>{e.target}</span>
            {e.reason && <span style={{ fontSize: 12, color: '#aaa' }}>{e.reason}</span>}
            <span style={{ fontSize: 11, color: '#ccc' }}>{new Date(e.created_at).toLocaleDateString('ru')}</span>
            <button onClick={() => del(e.id)} style={btnDanger}>🗑</button>
          </div>
        ))}
      </div>
    </div>
  );
}
